import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Guarantee() {
  return <section className="py-20 bg-brand-cream" data-id="element-97">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        <FadeIn data-id="element-99">
          <div className="bg-brand-blush/40 border-2 border-brand-rose/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-100">
            {/* Decorative background */}
            <div className="absolute top-0 left-0 w-full h-full opacity-30 pointer-events-none" data-id="element-101">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-white rounded-full blur-2xl" data-id="element-102"></div>
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-brand-rose rounded-full blur-3xl" data-id="element-103"></div>
            </div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-104">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-md mb-6 text-brand-rose" data-id="element-105">
                <ShieldCheckIcon className="w-10 h-10" data-id="element-106" />
              </div>

              <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-brown mb-4" data-id="element-107">
                Garantia Incondicional de 7 Dias
              </h2>

              <p className="text-lg text-brand-brown/80 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-108">
                Seu risco é zero. Se por qualquer motivo você não ficar 100%
                satisfeita com o conteúdo do ebook, basta enviar um email em até
                7 dias e devolvemos todo o seu dinheiro. Sem perguntas, sem
                burocracia.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}